import { TeamUserSummary, TeamUserCourseSummary } from '../types/teamUserSummary';
import { Badge, Certificate } from '../types/index';
import { get as apiGet, patch } from './apiService';

// Test mode for local development
// used in getTeamUserSummary() and getTeamUserCourseSummary()
// set to 1 or 2 for # rows of test data in your widgets
// anything > 0 will return team user course test data
let testMode = 0;

// Setter for test mode
export function setTestMode(value: number) {
  testMode = value;
}

// Progress Service
export class ProgressService {
  // Public Methods - Data Retrieval

  async getTeamUserSummary(profileId: string): Promise<TeamUserSummary> {
    let endpoint = `/profile/${profileId}/summary?expand=userCourses,badge`;

    const isLocal = !import.meta.env.VITE_ENV?.startsWith('prod');
    if (isLocal && testMode) endpoint += `&test=${testMode}`;

    return await apiGet<TeamUserSummary>(endpoint);
  }

  async getTeamUserCourseSummary(profileId: string): Promise<TeamUserCourseSummary[]> {
    let endpoint = `/profile/${profileId}/summary/course`;

    const isLocal = !import.meta.env.VITE_ENV?.startsWith('prod');
    if (isLocal && testMode) endpoint += `?test=${testMode}`;

    return await apiGet<TeamUserCourseSummary[]>(endpoint);
  }

  async getAllBadges(): Promise<Badge[]> {
    return await apiGet<Badge[]>('/badge');
  }

  async getAllCertificates(): Promise<Certificate[]> {
    return await apiGet<Certificate[]>('/certificate');
  }

  async markBadgeModalShown(profileId: string, badgeId: string): Promise<void> {
    // Update badge metadata to mark modal as shown
    await patch(`/profile/${profileId}/badge/${badgeId}`, {
      metadata: {
        modalShown: true,
        modalShownAt: new Date().toISOString(),
      },
    });
  }

}

// Export Singleton
export const progressService = new ProgressService();
